<h2 class="mb-2">Here are cleaners in your area, we will automatically select the most qualified cleaner for you.</h2>

<div class="text-text-tertiary leading-relaxed mb-6"
  >We will make sure that if one cancels, another can get it done. We partner with Cleanster to source trusted, verified
  cleaners in your area.</div
>

<ui-alert
  icon="griddy-shield-check"
  title="Backed by $2M in liability insurance"
  message="You're protected, every cleaning is covered for damages or accidents up to $2 million."
  [hideCloseButton]="true" />

@if (loading()) {
  <div class="mt-8 flex justify-center p-8">
    <ui-loading-spinner />
  </div>
} @else if (cleaners().length === 0) {
  <div class="mt-8 text-center text-text-tertiary p-8 border border-border-secondary rounded-xl">
    No cleaners available in your area at this time.
  </div>
} @else {
  <div class="mt-8 space-y-4">
    @for (cleaner of cleaners(); track cleaner.name) {
      <div>
        <sbnb-cleaner-card [cleaner]="cleaner" />
      </div>
    }
  </div>
}
